import { Component, Inject, Input, forwardRef } from '@angular/core';

import { AttachmentModel }                from './models/attachment';
import { AttachmentsService }             from './attachments.service';
import { AttachmentThumbnailStatusModel } from './models/attachment.thumbnail-status';

@Component({
  selector: 'wor-attachment',
  template: require('./attachment.component.html')
})
export class AttachmentComponent {
  @Input() attachment: AttachmentModel;

  thumbnailStatus: AttachmentThumbnailStatusModel = {
    isLoading    : true,
    isSuccessful : false,
    percentLoaded: 0
  };

  constructor (
    @Inject(forwardRef(() => AttachmentsService)) private attachmentsService: AttachmentsService
  ) {}

  ngOnInit(): void {
    this.attachmentsService.getThumbnails(this.thumbnailStatus, this.attachment);
  }

  isPdf(): boolean {
    return this.attachmentsService.isPdf(this.attachment);
  }

  showAttachment(): void {
    this.attachmentsService.showAttachment(this.attachment);
  }
}
